<template>
  <el-dialog :visible="true" fullscreen :show-close="false">
    <div class="h-full flex justify-center items-center">
      <div class="inline-block text-center">
        <img
          class="mx-auto"
          src="@/assets/layout/img/logo-ignition.svg"
          alt="Ignition logo"
        />
        <h1 class="p-3 text-5xl">Ignition</h1>

        <div class="text-3xl text-left mt-6 p-3">
          <p>Bienvenue {{ user && user.name }}!</p>
          <br />
          <p>
            Il semble que votre compte n'est pas encore autorisé à utiliser
            Ignition.
          </p>
          <p>
            Vous pouvez
            <a
              href="mailto:contact@delight-data.com"
              target="_top"
              class="text-blue-600 underline"
              >nous contacter</a
            >
            ou essayer de
            <a href="/" @click="logout" class="text-blue-600 underline"
              >vous connecter avec un autre compte</a
            >.
          </p>
          <br />
          <p>
            A bientôt,
            <br />
            L'équipe Delight.
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("auth");

export default {
  computed: mapState(["user"]),
  methods: mapActions(["logout"])
};
</script>

<style scoped></style>
